import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { getPaperCategoryList, getPaperListForExam } from "@/api/test-paper";
let SelectQuestionBox = class SelectQuestionBox extends Vue {
    constructor() {
        super(...arguments);
        this.questionDialog = false;
        this.libraryId = '0';
        this.innerLoading = false;
        this.search_content = "";
        this.paperName = '';
        this.pageSize = 15;
        this.pageIndex = 1;
        this.chosedId = [];
        this.chosedList = [];
        this.testPaperGroupList = [];
        this.questionList = [];
        this.flag = false;
        this.search_groups = '';
        this.totalPages = 0;
        this.existQ = false;
        this.showLoad = false;
        this.defaultProps = {
            children: "children",
            label: "name"
        };
        this.templateRadio = '';
    }
    get emptyImage() {
        return require("@/assets/empty.png");
    }
    handleSearchContentQuesLibChange(content) {
        this.tree.filter(content);
    }
    created() {
        this.questionDialog = this.choseQuestionDialog;
        this.getList();
    }
    handleNodeChange(_, node) {
        this.libraryId = "所有分类" == node.data.name ? '0' : node.data.id;
        this.pageIndex = 1;
        this.chosePaperListNode();
    }
    async getList() {
        this.showLoad = true;
        try {
            const res = await getPaperCategoryList(this.search_groups || void 0);
            this.testPaperGroupList = res.data.data;
            this.chosePaperListNode();
        }
        catch (_) { }
        finally {
            this.showLoad = false;
        }
    }
    async chosePaperListNode() {
        this.innerLoading = true;
        this.existQ = false;
        try {
            const res = await getPaperListForExam({
                content: this.paperName || void 0,
                categoryId: this.libraryId !== '0' ? this.libraryId : void 0,
                pageNo: this.pageIndex,
                pageSize: this.pageSize
            });
            const data = res.data.data;
            this.questionList = data.list;
            this.totalPages = Number(data.total);
            this.templateRadio = this.paperId;
        }
        catch (_) {
            this.getList();
        }
        finally {
            this.innerLoading = false;
        }
    }
    confirm() {
        this.questionDialog = false;
        this.$emit("confirm", this.templateRadio);
    }
    cancel() {
        this.questionDialog = false;
        this.$emit("cancel");
    }
    filterNode(value, data) {
        if (!value)
            return true;
        return data.name.indexOf(value) !== -1;
    }
    changeTemplateRadio(paper) {
        this.templateRadio = paper.id;
    }
    handleCurrentChange(pageIndex) {
        this.pageIndex = pageIndex;
        this.chosePaperListNode();
    }
    handleSizeChange(pageSize) {
        this.pageSize = pageSize;
        this.pageIndex = 1;
        this.chosePaperListNode();
    }
    handleSearchContent() {
        this.pageIndex = 1;
        this.paperName = this.search_content;
        this.chosePaperListNode();
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], SelectQuestionBox.prototype, "examId", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], SelectQuestionBox.prototype, "paperId", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], SelectQuestionBox.prototype, "choseQuestionDialog", void 0);
tslib_1.__decorate([
    Ref()
], SelectQuestionBox.prototype, "tree", void 0);
tslib_1.__decorate([
    Watch('search_groups')
], SelectQuestionBox.prototype, "handleSearchContentQuesLibChange", null);
SelectQuestionBox = tslib_1.__decorate([
    Component({
        name: 'SelectPaperBox',
        filters: {
            disableTooltip(e, t) {
                var n = /[\da-zA-Z]/, o = /[\u4e00-\u9fa5]/;
                let a = 0;
                for (let i = 0; i < e.length; i++)
                    if (!n.test(e[i]) && o.test(e[i]) ? a += 2 : a++,
                        a >= t)
                        return !1;
                return !0;
            }
        }
    })
], SelectQuestionBox);
export default SelectQuestionBox;
